import * as selectors from './userPreferencesSelectors';
import * as actions from './userPreferencesActions';
import reducer from './userPreferencesReducer';

export { selectors, actions, reducer };
